import React from 'react'

export function useServerErrors(initialErrors?: Record<string,string>): [Record<string,string> | undefined, Function] {
    const [errors, setErrors] = React.useState(initialErrors)

    function applyErrors(error?: Error) {
        if (!error) return setErrors(undefined)
        setErrors(JSON.parse(error.message))
    }

    return [errors, applyErrors]
}
